"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolEditor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_styled_components_1 = require("../../../common-styled-components");
const TextInput_1 = require("../../../generic/TextInput");
const NumberInput_1 = require("../../../generic/NumberInput");
const PoolEditor = ({ state, updateValue, modalType, }) => {
    if (modalType === "remove") {
        return (0, jsx_runtime_1.jsxs)("div", { children: ["Remove ", state.name, "?"] });
    }
    return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Pool name" }), (0, jsx_runtime_1.jsx)(TextInput_1.TextInput, { value: state.name ?? "", onChange: (newValue) => updateValue("name", newValue) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Year" }), (0, jsx_runtime_1.jsx)(NumberInput_1.NumberInput, { value: state.year !== undefined && !isNaN(state.year) ? state.year : "", onChange: (newValue) => updateValue("year", !isNaN(Number(newValue)) ? Number(newValue) : undefined) })] }));
};
exports.PoolEditor = PoolEditor;
